import { useQuery } from 'react-query';
import { landingPageDesignGroupsKeys } from './keys';
import { EXPRESS_API } from 'configs/api/expressApi';
import { ILandingPageDesignGroup } from 'app/pages/admin/landing-pages-v2/types';
import { errorToast } from 'lib/components/toasts/error';

const getAllGroups = async () => {
  return (await EXPRESS_API.get(`/superadmin/landing-page-design-groups`))
    .data as ILandingPageDesignGroup[];
};

export const useQueryGetAllGroups = () => {
  return useQuery(landingPageDesignGroupsKeys.all(), () => getAllGroups(), {
    enabled: true,
    onError: () => {
      errorToast({
        title: `We're currently experiencing difficulties fetching groups.`,
      });
    },
  });
};
